import Vue from 'vue';

// 使用 Event Bus
const bus = new Vue();

export default bus;


//leftMenu    Login页 登录后，根据角色 作用到了Sidebar.vue，  根据权限刷新左菜单框

//svnEditId   svn修改人员页, 使用其传递 id

//svnSessId   svn登陆后 身份令牌